import { createAsyncThunk } from '@reduxjs/toolkit';
import { userApi } from '~/apis/user';
import { GET_PROFILE, GET_STUDENT, UPDATE_PROFILE } from '~/utils/constants/actionType';
import { IQueryGetStudent } from '~/utils/interface/account';

export const getProfile = createAsyncThunk(GET_PROFILE, async (_, { rejectWithValue }) => {
  try {
    const res = await userApi.getProfile();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateProfile = createAsyncThunk(UPDATE_PROFILE, async (body: FormData, { rejectWithValue }) => {
  try {
    const res = await userApi.updateProfile(body);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getStudents = createAsyncThunk(GET_STUDENT, async (payload: IQueryGetStudent, { rejectWithValue }) => {
  try {
    const res = await userApi.getStudents(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
